const toNumber = (value, fallback = 0) => {
    const num = parseFloat(value);
    return Number.isFinite(num) ? num : fallback;
};

const timeToMinutes = (value) => {
    if (!value || typeof value !== "string") return null;
    const parts = value.split(":");
    if (parts.length < 2) return null;
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return null;
    return (hours * 60) + minutes;
};

const isWithinTimeWindow = (rule, timestamp) => {
    const start = timeToMinutes(rule.startTime);
    const end = timeToMinutes(rule.endTime);
    if (start === null || end === null) return false;

    const date = timestamp ? new Date(timestamp) : new Date();
    const current = (date.getHours() * 60) + date.getMinutes();

    if (start === end) return true;
    if (start < end) {
        return current >= start && current < end;
    }
    return current >= start || current < end;
};

const shouldApplyRule = (rule, rateDetails, context) => {
    if (!rule || !rule.enabled) return false;
    if (rule.scope === "carType" && rule.carType && rateDetails && rateDetails.name !== rule.carType) return false;
    if (rule.type === "time_window") {
        return isWithinTimeWindow(rule, context && context.timestamp);
    }
    return rule.type === "surge" || rule.type === "weather" || rule.type === "platform_fee" || rule.type === "custom";
};

const applyFareRules = (amount, fareRules, rateDetails, decimal, context) => {
    const activeRules = Array.isArray(fareRules) ? fareRules
        .filter(rule => shouldApplyRule(rule, rateDetails, context))
        .sort((a, b) => toNumber(a.priority) - toNumber(b.priority))
        : [];

    let adjustedTotal = amount;
    const appliedAdjustments = [];

    activeRules.forEach((rule) => {
        const value = toNumber(rule.value);
        if (value <= 0) return;

        const adjustmentAmount = rule.mode === "flat"
            ? value
            : (amount * value / 100);
        const payoutType = rule.payoutType || (rule.type === "platform_fee" ? "admin_only" : "rider_only");
        let riderShare = 0;
        let adminShare = 0;

        if (payoutType === "admin_only") {
            adminShare = adjustmentAmount;
        } else if (payoutType === "split") {
            const riderPercent = toNumber(rule.riderSharePercent, 50);
            riderShare = adjustmentAmount * riderPercent / 100;
            adminShare = adjustmentAmount - riderShare;
        } else {
            riderShare = adjustmentAmount;
        }

        adjustedTotal = adjustedTotal + adjustmentAmount;
        appliedAdjustments.push({
            id: rule.id || null,
            type: rule.type,
            label: rule.label || rule.name || rule.type,
            mode: rule.mode || "percentage",
            value: value,
            amount: parseFloat(adjustmentAmount.toFixed(decimal)),
            payoutType,
            riderShare: parseFloat(riderShare.toFixed(decimal)),
            adminShare: parseFloat(adminShare.toFixed(decimal))
        });
    });

    const adjustmentTotal = appliedAdjustments.reduce((total, item) => total + toNumber(item.amount), 0);
    const riderAdjustmentShare = appliedAdjustments.reduce((total, item) => total + toNumber(item.riderShare), 0);
    const adminAdjustmentShare = appliedAdjustments.reduce((total, item) => total + toNumber(item.adminShare), 0);
    const platformFeeTotal = appliedAdjustments
        .filter(item => item.type === "platform_fee")
        .reduce((total, item) => total + toNumber(item.amount), 0);

    return {
        adjustedTotal,
        adjustmentTotal: parseFloat(adjustmentTotal.toFixed(decimal)),
        riderAdjustmentShare: parseFloat(riderAdjustmentShare.toFixed(decimal)),
        adminAdjustmentShare: parseFloat(adminAdjustmentShare.toFixed(decimal)),
        platformFeeTotal: parseFloat(platformFeeTotal.toFixed(decimal)),
        appliedAdjustments
    };
};

export const FareCalculator = (distance,time,rateDetails,instructionData, decimal, fareRules, context)=>{

    let baseCalculated =  (toNumber(rateDetails.rate_per_unit_distance) * toNumber(distance)) + (toNumber(rateDetails.rate_per_hour) * (toNumber(time) / 3600));
    if(toNumber(rateDetails.base_fare)>0){
        baseCalculated = baseCalculated + toNumber(rateDetails.base_fare);
    }
    if(instructionData && instructionData.parcelTypeSelected){
        baseCalculated = baseCalculated + toNumber(instructionData.parcelTypeSelected.amount);
    }
    if(instructionData && instructionData.optionSelected){
        baseCalculated = baseCalculated + toNumber(instructionData.optionSelected.amount);
    }
    let total = baseCalculated > toNumber(rateDetails.min_fare) ? baseCalculated : toNumber(rateDetails.min_fare);
    const baseFareBeforeAdjustments = total;
    const {
        adjustedTotal,
        adjustmentTotal,
        riderAdjustmentShare,
        adminAdjustmentShare,
        platformFeeTotal,
        appliedAdjustments
    } = applyFareRules(total, fareRules, rateDetails, decimal, context);
    total = adjustedTotal;

    let convenienceFee = 0;
    const convenienceBase = baseFareBeforeAdjustments + riderAdjustmentShare;
    if(rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat'){
        convenienceFee = toNumber(rateDetails.convenience_fees);
    }else{
        convenienceFee = (convenienceBase*toNumber(rateDetails.convenience_fees)/100);
    }
    let grand = total + convenienceFee;

    return {
        totalCost:parseFloat(total.toFixed(decimal)),
        grandTotal:parseFloat(grand.toFixed(decimal)),
        convenience_fees:parseFloat(convenienceFee.toFixed(decimal)),
        baseFareBeforeAdjustments: parseFloat(baseFareBeforeAdjustments.toFixed(decimal)),
        adjustmentTotal,
        riderAdjustmentShare,
        adminAdjustmentShare,
        platformFeeTotal,
        fareAdjustments: appliedAdjustments
    }
     
}
